<template>
  <div class="page_content explore_entity_inside faq program_guide_compliance" aria-label="program guide compliance">

    <div class="row page-heading">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
            <span class="module_icon icon-list"></span>
            <template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
          </div>
    </div>


    <div class="page_content_container">
        <div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
            <program-guide-menu
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :returnTo="returnTo"
                :active="'compliance'">
            </program-guide-menu>
        </div>
        <div class="pg_content">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

                <div class="row sub_hd first_hd">
                  <div class="col-8 hd_txt">
                    <div class="txt" v-if="programGuideObject.institutionSpecificInfo.label">
                      {{programGuideObject.institutionSpecificInfo.label}}
                    </div>
                    <div class="compliant_score_val">
                      <span v-if="programGuideObject.institutionSpecificInfo.tag">{{programGuideObject.institutionSpecificInfo.tag}}</span>
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 search_bx_sec">
                    <div class="search-box-container">
                      <input class="input-search" placeholder="search" aria-label="search" v-model="searchTerm" v-on:keyup.enter="searchClicked">
                      <b-btn class="btn btn_srh" @click="searchClicked"><span class="fas fa-search" aria-label="search"></span></b-btn>
                    </div>
                  </div>
                </div>

                <div class="row list_row pg_top_sec">
                  <div class="col-12">

                    <div class="row credential_intro_sec">
                      <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 thumbnail_container" v-if="programGuideObject.institutionSpecificInfo.iconUrl">
                        <img :src="programGuideObject.institutionSpecificInfo.iconUrl" class="img_h_100">
                      </div>

                      <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 entity_detail_section" :class="programGuideObject.institutionSpecificInfo.iconUrl ? 'col-xl-9 col-lg-9 col-md-12 col-sm-12' : 'col-xl-12 col-lg-12 col-md-12 col-sm-12'">
                        <div v-if="programGuideObject.institutionSpecificInfo.detail" v-html="programGuideObject.institutionSpecificInfo.detail">
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <template v-if="filteredCompliance.length == 0">
                  <div class="list_row">
                    No results found!
                  </div>
                </template>
                <template v-for="(compliance, i) in filteredCompliance">
                  <div class="accordion_panel">
                    <template v-if="(compliance.items && compliance.items.length>0)">
                      <div class="accordion_crd">
                          <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle="('req_'+i)" variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 hd_txt">
                              <div>{{compliance.label}}</div>
                            </div>
                          </b-card-header>

                          <b-collapse :id="'req_'+i" visible role="tabpanel">
                            <b-card-body class="accordion_crd_content">
                                <div v-if="compliance.detail" v-html="compliance.detail">
                                </div>
                                <div class="self_reported_courses">
                                  <div class="">
                                    <template v-for="(complianceItem, j) in compliance.items">
                                        <div class="row list_row" v-if="complianceItem.title">
                                          <div class="col-12 sec_hd">
                                            <div v-html="parseParams(complianceItem.title)"></div>
                                          </div>
                                        </div>
                                        <div class="row list_row" v-if="complianceItem.description">
                                          <div class="col-12 sec_txt">
                                            <div v-html="parseParams(complianceItem.description)"></div>
                                          </div>
                                        </div>
                                    </template>
                                  </div>
                                </div>

                            </b-card-body>
                          </b-collapse>
                        </div>
                      </template>
                    </div>
                  </template>

            </div>
        </div> <!-- .pg_content -->

    </div> <!-- .page_content_container -->


    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
export default {
  name: 'program-guide-compliance',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle
  },
  data: () => {
    return {
      isDataLoaded: false,
      DEFAULT_TYPE: 'MAJOR',
      filteredCompliances:[],
      searchTerm :'',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      newForm: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    }
  },
beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: 'Cannot move past this page till account setup is complete'
      })
      this.showNewFormPopup()
      this.nextPage = next
    } else {
      // Navigate to next view
      next()
    }
  },
  async mounted () {
      this.programGuideObject = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadFinishAccountSetup',
      'loadProgramGuideCareers',
      'setTemporaryUserToFalse'
    ]),
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    launch (object) {
        if(object.url){
          window.open(object.url, '_blank')
        }
    },

    searchClicked(){
      if(!this.searchTerm){
          this.filteredCompliances = this.programGuideObject.institutionSpecificInfo.subGroups
      }else{
          let filtered = []
          this.programGuideObject.institutionSpecificInfo.subGroups.forEach((compliance) => {
              let newCompliance  = {'label':compliance.label, 'items':[]}
              compliance.items.forEach((item) => {
                  if(item.title.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 || item.description.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 )
                  newCompliance.items.push(item)
              });
              filtered.push(newCompliance)
          });
          this.filteredCompliances = filtered;
      }
    },
    async registerProspectiveStudent () {
      if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'First Name, Last Name and Password are required'
        })
      } else if (this.newForm.password !== this.repassword) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do no match'
        })
      } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Phone Number is required'
        })
      } else {
        this.$refs.loadingModal.show()
        await this.loadFinishAccountSetup(this.newForm)
        let bool = false
        this.setTemporaryUserToFalse()
        this.nextPage()
      }
    },
    showNewFormPopup (popupPosition) {
      this.$refs.newFormModal.show()
      $('.usr_verification_popup').removeClass('showAtTop')
      $('.usr_verification_popup').removeClass('showAtBottom')
      $('.usr_verification_popup').addClass('showAtTop')
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
      this.$parent.isShowTagPopup = false
      this.newForm = {
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    },
    parseParams(value){
      let parsedValue = value
      if(parsedValue.indexOf('[MEDIAN_INCOME]')!=-1) {
        let medianIncome = this.programGuideObject.medianIncomePerYear
         medianIncome = medianIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        parsedValue = value.replace('[MEDIAN_INCOME]', '$' + medianIncome)
      }
      if(parsedValue.indexOf('[GROWTH_RATE]')!=-1) {
        let growthRate = parseFloat(this.programGuideObject.growthRate).toFixed(1)
        parsedValue = parsedValue.replace('[GROWTH_RATE]', growthRate+'%')
      }
      if(parsedValue.indexOf('[CREDENTIALS]')!=-1) {
        let credList = '<ul>'
        if(this.programGuideObject.credentialList.length>0){
            for(let i=0;i<this.programGuideObject.credentialList.length;i++){
                credList+='<li>'+this.programGuideObject.credentialList[i].title+'</li>'
            }
        }
        credList+='</ul>'
        parsedValue = parsedValue.replace('[CREDENTIALS]', credList)
      }
      if(parsedValue.indexOf('[CREDIT_TRANSFER]')!=-1) {
        let transfer = '<ul>'
        if(this.programGuideObject.relatedProgramsCreditInfo.length>0){
            for(let i=0; i<this.programGuideObject.relatedProgramsCreditInfo.length;i++){
                transfer+='<li>'+this.programGuideObject.relatedProgramsCreditInfo[i].transferred+' credits towards  '+this.programGuideObject.relatedProgramsCreditInfo[i].programName+'</li>'
            }
        }
        transfer+='</ul>'
        parsedValue = parsedValue.replace('[CREDIT_TRANSFER]', transfer)
      }
      if(parsedValue.indexOf('[MODALITY_TYPE]')!=-1) {
        let modalityType = this.getModalityValue(this.programGuideObject.modalityType)
        parsedValue = parsedValue.replace('[MODALITY_TYPE]', modalityType)
      }
      if(parsedValue.indexOf('[FUNDING_TYPE]')!=-1) {
        let fundingType = this.getFundingValue(this.programGuideObject.fundingType)
        parsedValue = parsedValue.replace('[FUNDING_TYPE]', fundingType)
      }

      return parsedValue
    },
    getModalityValue(key){
        let arr = [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },
  computed: {
    ...mapState({
      'programGuideObject': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'institution': state => state.institution.institution,
      'packages': state => state.institution.packages
    }),
  formattedProgramGuide () {
      let formattedProgramGuide = this.programGuideObject
      this.filteredCompliances = (formattedProgramGuide.institutionSpecificInfo && formattedProgramGuide.institutionSpecificInfo.subGroups)?formattedProgramGuide.institutionSpecificInfo.subGroups:[]
      return formattedProgramGuide
    },
    filteredCompliance () {
      return this.filteredCompliances
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCompliance.vue